module.exports = __webpack_public_path__ + "static/media/Words.cbf1a66f.mp3";